import {
    PlusIcon,
    TrashIcon
} from "@primer/octicons-react";
import { Box, Checkbox } from "@primer/react";
import { useEffect, useState } from "react";
import { hinhThucMienGiamApi } from "../../../api/hinhThucMienGiamApi";
import Button from "../../../components/ui/button";
import MyIconButton from "../../../components/ui/button/IconButton";
import DataTable from "../../../components/ui/data-table";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { sf_hinhthucmiengiam } from "../../../models/response/category/sf_hinhthucmiengiam";
import { sf_hinhthucmiengiam_chitiet_viewmodel } from "../../../models/response/category/sf_hinhthucmiengiam_chitiet";
import { MienGiamEditItemsModal } from "./edit_modal";
type MienGiamItemsModalProps = {
    animationOf: string,
    sf_hinhthucmiengiam: sf_hinhthucmiengiam,
    onClose: () => void,
    onEditRequest: () => void
}
export const MienGiamItemsModal = (props: MienGiamItemsModalProps) => {
    const [sf_hinhthucmiengiam_chitiets, set_sf_hinhthucmiengiam_chitiets] = useState<sf_hinhthucmiengiam_chitiet_viewmodel[]>([])
    const [isShowEditPopUp, SetIsShowEditPopUp] = useState<boolean>(false);
    useEffect(() => {
        getHinhThucMienGiamChiTiets(props.sf_hinhthucmiengiam.id)

    }, [props.sf_hinhthucmiengiam])
    const getHinhThucMienGiamChiTiets = async (sf_hinhthucmiengiam_id: number) => {
        let isLoading: boolean = true;
        const interval_obj = setInterval(() => {
            if (!isLoading) {
                clearInterval(interval_obj);
            }
        }, 800)

        const res = await hinhThucMienGiamApi.select_chitiets(sf_hinhthucmiengiam_id)
        if (res.is_success) {
            set_sf_hinhthucmiengiam_chitiets(res.data.sort((a: any, b: any) =>
                a.thutu_sapxep_nhomkhoannop - b.thutu_sapxep_nhomkhoannop || a.thutu_sapxep - b.thutu_sapxep
            ))
        }
        isLoading = false;
    }
    const handleDeleteMienGiamChiTiet = async (id: number) => {
        const res = await hinhThucMienGiamApi.deleteChiTiet(id);
        if (res.is_success) {
            getHinhThucMienGiamChiTiets(props.sf_hinhthucmiengiam.id);
        }
    }
    const handleCheckBoxChange = async (e: React.ChangeEvent<HTMLInputElement>, cellData: any) => {
        cellData.is_huonguudai_duynhat = e.target.checked;
        await hinhThucMienGiamApi.save_miengiam_chitiet(cellData);
        getHinhThucMienGiamChiTiets(props.sf_hinhthucmiengiam.id);
    };

    const cellRender = (data: any) => {
        return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <MyIconButton
                    aria-label="Xóa khoản nộp"
                    icon={TrashIcon}
                    variant="invisible"
                    size="small"
                    onClick={() => {
                        handleDeleteMienGiamChiTiet(data.id);
                    }}
                    sx={{
                        color: "#d1242f",
                        "&:hover": {
                            color: "#a40e26",
                            backgroundColor: "#ffebe9"
                        },
                        minWidth: "28px",
                        minHeight: "28px",
                        padding: "4px"
                    }}
                />
            </Box>
        );
    };
    const columns = (() => {
        const result: any = [
            {
                id: "actions",
                caption: "#",
                width: "40px",
                align: "center",
                cellRender: (cellData: any) => {
                    return cellRender(cellData);
                },
            },
            {
                caption: "Khoản nộp",
                id: "khoan_nop",
                dataField: "ten_khoan_nop",
                width: "200px",
                cellRender: (data: any) => (
                    <Box>
                        <Box sx={{ fontWeight: "600", color: "#24292f", mb: 0.5 }}>
                            <TextWithEllipse text={data.ten_khoan_nop || ""} lineNumber={1} />
                        </Box>
                        <Box sx={{
                            fontWeight: "500",
                            color: "#656d76",
                            fontSize: "12px",
                            fontStyle: "italic"
                        }}>
                            <TextWithEllipse text={data.ma_khoan_nop || ""} lineNumber={1} />
                        </Box>
                    </Box>
                ),
            },
            {
                caption: "Miễn giảm theo",
                columns: [
                    {
                        caption: "(%)",
                        id: "phan_tram_mien_giam",
                        dataField: "phan_tram_mien_giam",
                        width: "60px",
                        cellRender: (data: any) => (
                            <Box sx={{
                                fontWeight: "600",
                                color: data.phan_tram_mien_giam ? "#0969da" : "#8c959f",
                                textAlign: "right"
                            }}>
                                {data.phan_tram_mien_giam || ""}
                            </Box>
                        ),
                    },
                    {
                        caption: "Số tiền",
                        id: "so_tien_mien_giam",
                        dataField: "so_tien_mien_giam",
                        width: "80px",
                        align: 'right',
                        cellRender: (data: any) => (
                            <Box sx={{
                                fontWeight: "600",
                                color: data.so_tien_mien_giam ? "#0969da" : "#8c959f",
                                textAlign: "right"
                            }}>
                                {data.so_tien_mien_giam || ""}
                            </Box>
                        ),
                    },
                    {
                        caption: "Ưu đãi duy nhất",
                        id: "is_huonguudai_duynhat",
                        dataField: "is_huonguudai_duynhat",
                        width: "140px",
                        cellRender: (data: any) => (
                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                py: 1
                            }}>
                                <Checkbox
                                    checked={data.is_huonguudai_duynhat === true}
                                    aria-label="Hưởng duy nhất ưu đãi này"
                                    onChange={(e) => handleCheckBoxChange(e, data)}
                                    sx={{
                                        border: "2px solid #d1d9e0",
                                        "&:checked": {
                                            backgroundColor: "#0969da",
                                            borderColor: "#0969da"
                                        }
                                    }}
                                />
                            </Box>
                        ),
                    },
                ],
            },
        ];
        return result;
    })();
    return (
        <Box>
            <DataTable
                data={sf_hinhthucmiengiam_chitiets}
                height="calc(100vh - 200px)"
                actionComponent={
                    <Button
                        variant="primary"
                        size="small"
                        leadingVisual={PlusIcon}
                        onClick={() => SetIsShowEditPopUp(true)}
                    >
                        {sf_hinhthucmiengiam_chitiets.length === 0 ? "Thêm mới" : "Điều chỉnh"}
                    </Button>
                }
                columns={columns}
                paging={{
                    enable: true,
                    pageSizeItems: [20, 50, 100, 200],
                }}
            />
            {isShowEditPopUp && <MienGiamEditItemsModal
                animationOf="#btnEditItems"
                onChanged={() => {
                    SetIsShowEditPopUp(false);
                    getHinhThucMienGiamChiTiets(props.sf_hinhthucmiengiam.id);
                }}
                onClose={() => { SetIsShowEditPopUp(false) }}
                sf_hinhthucmiengiam={props.sf_hinhthucmiengiam}
            />}
        </Box>
    );
}